function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var DS = window.WinBoostAiDesignSystem_0f78b0 || {};
var Button = DS.Button,
  IconButton = DS.IconButton,
  Card = DS.Card,
  Badge = DS.Badge,
  CheckItem = DS.CheckItem,
  SectionLabel = DS.SectionLabel,
  Icon = DS.Icon,
  Orbit = DS.Orbit,
  Waveform = DS.Waveform,
  Logo = DS.Logo,
  Accordion = DS.Accordion,
  Field = DS.Field,
  Select = DS.Select,
  PatternBackdrop = DS.PatternBackdrop,
  StatBlock = DS.StatBlock;
var dealStyle = function dealStyle(i) {
  return {
    animationDelay: (i * 0.11).toFixed(2) + 's'
  };
};
var TOOLS_A = ['Google Calendar', 'HubSpot', 'Salesforce', 'GoHighLevel', 'Calendly', 'Jobber'];
var TOOLS_B = ['Slack', 'Zapier', 'Twilio', 'Stripe', 'Outlook', 'Microsoft Teams'];
function MarqueeRow(_ref) {
  var items = _ref.items,
    reverse = _ref.reverse;
  var plate = {
    flex: 'none',
    border: '1px solid var(--border-card)',
    borderRadius: 'var(--radius-md)',
    background: 'var(--wb-white)',
    padding: '20px 30px',
    fontSize: 14,
    fontWeight: 800,
    color: 'var(--ink-600)',
    whiteSpace: 'nowrap'
  };
  var row = [].concat(_toConsumableArray(items), _toConsumableArray(items), _toConsumableArray(items), _toConsumableArray(items));
  return React.createElement("div", {
    style: {
      overflow: 'hidden',
      maskImage: 'linear-gradient(90deg,transparent,#000 7%,#000 93%,transparent)',
      WebkitMaskImage: 'linear-gradient(90deg,transparent,#000 7%,#000 93%,transparent)'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      gap: 16,
      width: 'max-content',
      animation: (reverse ? 'wbMarqueeR' : 'wbMarqueeL') + ' 34s linear infinite'
    }
  }, row.map(function (t, i) {
    return React.createElement("div", {
      key: t + i,
      style: plate
    }, t);
  })));
}
function Integrations() {
  return React.createElement(Section, {
    id: "integrations"
  }, React.createElement("style", null, '@keyframes wbMarqueeL{from{transform:translateX(0)}to{transform:translateX(-25%)}}@keyframes wbMarqueeR{from{transform:translateX(-25%)}to{transform:translateX(0)}}@media(prefers-reduced-motion:reduce){#integrations [style*="wbMarquee"]{animation:none!important}}'), React.createElement(Head, {
    index: "15",
    label: "Integrations",
    title: "Works with the tools you already use.",
    lead: "Your AI Phone writes into the calendar, CRM and inbox your team already lives in.",
    align: "center"
  }), React.createElement("div", {
    style: {
      display: 'grid',
      gap: 16
    }
  }, React.createElement(MarqueeRow, {
    items: TOOLS_A
  }), React.createElement(MarqueeRow, {
    items: TOOLS_B,
    reverse: true
  })));
}
function LiveBooking() {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    booked = _React$useState2[0],
    setBooked = _React$useState2[1];
  var slots = ['9:00', '10:30', '13:00', '14:30', '16:00'];
  return React.createElement(Section, {
    id: "live-booking",
    style: {
      background: 'var(--wb-charcoal)'
    }
  }, React.createElement(Head, {
    index: "07",
    label: "AI Phone to calendar",
    title: "AI Automated Workflow with infinite possibilities",
    lead: "The conversation is only half of it. Watch the appointment land in the calendar before the call ends.",
    inverse: true
  }), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1.15fr',
      gap: 44,
      alignItems: 'stretch'
    }
  }, React.createElement(Card, {
    surface: "inverse",
    padding: "lg",
    radius: "xl",
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 22,
      position: 'relative',
      overflow: 'hidden'
    }
  }, React.createElement(Orbit, {
    size: 170,
    state: booked ? 'breathing' : 'speaking',
    halo: !booked,
    basePath: A
  }), React.createElement(SoundRibbon, {
    height: 24,
    active: !booked
  }), React.createElement(Badge, {
    tone: booked ? 'success' : 'inverse',
    dot: true,
    pulse: !booked
  }, booked ? 'Appointment confirmed' : 'Checking availability…'), React.createElement("p", {
    style: {
      fontSize: 15,
      color: 'var(--text-inverse-muted)',
      textAlign: 'center'
    }
  }, "\u201CThursday at 10:30 works. I\u2019ve got you booked and I\u2019ll text the confirmation now.\u201D")), React.createElement(Card, {
    surface: "white",
    padding: "lg",
    radius: "xl"
  }, React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 20
    }
  }, React.createElement("div", null, React.createElement("div", {
    style: {
      fontSize: 'var(--fs-h4)',
      fontWeight: 800
    }
  }, "Thursday, 14 August"), React.createElement("span", {
    className: "mono"
  }, "Acme Plumbing \xB7 Team calendar")), React.createElement(Icon, {
    name: "calendar",
    size: 32,
    basePath: ICONS
  })), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10
    }
  }, slots.map(function (s) {
    var isNew = s === '10:30' && booked;
    return React.createElement("div", {
      key: s,
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        padding: '14px 16px',
        borderRadius: 'var(--radius-md)',
        border: '1px solid ' + (isNew ? 'var(--green-500)' : 'var(--border-card)'),
        background: isNew ? 'var(--green-100)' : s === '13:00' ? 'var(--sand-100)' : 'var(--wb-white)',
        transition: 'all var(--dur-base) var(--ease-out)'
      }
    }, React.createElement("span", {
      className: "mono",
      style: {
        width: 44
      }
    }, s), React.createElement("span", {
      style: {
        fontSize: 14,
        fontWeight: 700,
        flex: 1
      }
    }, isNew ? 'New patient consult, booked by AI Phone' : s === '13:00' ? 'Site visit: Rivera' : 'Available'), isNew && React.createElement(Badge, {
      tone: "success",
      dot: true
    }, "Confirmed"));
  })), React.createElement("div", {
    style: {
      marginTop: 24,
      display: 'flex',
      gap: 12,
      alignItems: 'center'
    }
  }, React.createElement(Button, {
    variant: "primary",
    arrow: true,
    onClick: function onClick() {
      return setBooked(!booked);
    }
  }, booked ? 'Reset demo' : 'Book the appointment'), booked && React.createElement("span", {
    style: {
      fontSize: 14,
      fontWeight: 800,
      color: 'var(--green-500)'
    }
  }, "SMS confirmation sent")))));
}
function PortalPreview() {
  var ref = React.useRef(null),
    _React$useState3 = React.useState(.6),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    s = _React$useState4[0],
    setS = _React$useState4[1];
  React.useEffect(function () {
    var el = ref.current;
    if (!el) return;
    var f = function f() {
      return setS(el.clientWidth / 1440);
    };
    f();
    var ro = new ResizeObserver(f);
    ro.observe(el);
    return function () {
      return ro.disconnect();
    };
  }, []);
  return React.createElement("div", {
    ref: ref,
    "aria-hidden": "true",
    style: {
      display: 'block',
      position: 'relative',
      height: 900 * s,
      borderRadius: 'var(--radius-xl)',
      overflow: 'hidden',
      border: '1px solid var(--border-card)',
      boxShadow: 'var(--shadow-md)',
      background: 'var(--wb-cream)'
    }
  }, React.createElement("div", {
    className: "wb-pp-inline",
    style: {
      width: 1440,
      height: 900,
      transform: 'scale(' + s + ')',
      transformOrigin: '0 0',
      pointerEvents: 'none',
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0
    }
  }, window.WB_PortalApp ? React.createElement(window.WB_PortalApp) : null));
}
function Portal() {
  return React.createElement(Section, {
    id: "portal",
    style: {
      background: 'var(--wb-white)',
      borderTop: '1px solid var(--border-hairline)',
      borderBottom: '1px solid var(--border-hairline)'
    }
  }, React.createElement(Head, {
    index: "07",
    label: "Client portal",
    title: "Everything in one place.",
    lead: "Every call, transcript, booking and follow-up your AI Phone handled, visible the moment it happens."
  }), React.createElement(PortalPreview, null), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))',
      columnGap: 40,
      rowGap: 16,
      marginTop: 26,
      alignItems: 'start'
    }
  }, React.createElement(CheckItem, null, "Call log with recordings and transcripts"), React.createElement(CheckItem, null, "Bookings and no-show tracking"), React.createElement(CheckItem, null, "Usage and billing, no subscription"), React.createElement(CheckItem, null, "SMS threads and review requests"), React.createElement(CheckItem, null, "AI summary of every call"), React.createElement(CheckItem, null, "Direct line to your AI Phone Builder")));
}
var HIGH5 = [['HUMAN FIRST', 'Technology should sound and feel more human, not less.'], ['ALWAYS ON', 'Every opportunity deserves an answer.'], ['BUILT TO WIN', 'Everything we build has a purpose: Results.'], ['TOGETHER WE WIN', 'Your success is our success.'], ['RAISE THE BAR', 'Better is something we build every day.']];
function HighFive() {
  return React.createElement(Section, {
    id: "high-five"
  }, React.createElement(Head, {
    index: "18",
    label: "Why WinBoost",
    title: "The WinBoost High 5.",
    align: "center"
  }), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5,1fr)',
      gap: 0,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, HIGH5.map(function (_ref2, i) {
    var _ref3 = _slicedToArray(_ref2, 2),
      t = _ref3[0],
      d = _ref3[1];
    return React.createElement("div", {
      key: t,
      style: {
        padding: '32px 26px',
        borderLeft: i ? '1px solid var(--border-hairline)' : 'none'
      }
    }, React.createElement("div", {
      className: "wb-label",
      style: {
        color: 'var(--wb-orange)',
        marginBottom: 14
      }
    }, t), React.createElement("p", {
      style: {
        fontSize: 15,
        color: 'var(--text-secondary)'
      }
    }, d));
  })));
}
var GFX_LANE = {
  position: 'relative',
  height: 10,
  borderRadius: 999,
  background: 'var(--sand-200)',
  overflow: 'hidden'
};
var GFX_DOT = {
  position: 'absolute',
  top: 0,
  width: 10,
  height: 10,
  borderRadius: 999,
  background: 'var(--grad-brand)'
};
function GfxFlow() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, React.createElement("span", {
    className: "mono"
  }, "Inbound"), React.createElement("span", {
    className: "mono"
  }, "answered")), React.createElement("div", {
    style: GFX_LANE
  }, React.createElement("span", {
    className: "wb-g-dotr",
    style: GFX_DOT
  })), React.createElement("div", {
    style: GFX_LANE
  }, React.createElement("span", {
    className: "wb-g-dotl",
    style: GFX_DOT
  })), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, React.createElement("span", {
    className: "mono"
  }, "followed up"), React.createElement("span", {
    className: "mono"
  }, "Outbound")));
}
function GfxSpeed() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
    }
  }, React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "AI Phone"), React.createElement("span", {
    style: {
      fontSize: 15,
      fontWeight: 800,
      letterSpacing: '-.02em'
    }
  }, "0.6s")), React.createElement("div", {
    className: "wb-g-fill",
    style: GFX_LANE
  }, React.createElement("i", null)), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
    }
  }, React.createElement("span", {
    className: "mono"
  }, "Voicemail callback"), React.createElement("span", {
    style: {
      fontSize: 15,
      fontWeight: 800,
      letterSpacing: '-.02em',
      color: 'var(--ink-400)'
    }
  }, "hours")), React.createElement("div", {
    className: "wb-g-slow",
    style: GFX_LANE
  }, React.createElement("i", null)));
}
function GfxQualify() {
  var rows = [['Calls answered', '100%', '100%'], ['Qualified', ' ', '80%'], ['Booked', ' ', '56%'], ['Closed', ' ', '34%']];
  return React.createElement("div", {
    className: "wb-g-step",
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 5
    }
  }, rows.map(function (_ref4, i) {
    var _ref5 = _slicedToArray(_ref4, 3),
      l = _ref5[0],
      w = _ref5[2];
    return React.createElement("div", {
      key: l,
      style: {
        position: 'relative',
        width: w,
        height: 30,
        background: 'var(--sand-200)',
        clipPath: 'polygon(0 0,100% 0,' + (100 - 9) + '% 100%,9% 100%)',
        display: 'grid',
        placeItems: 'center'
      }
    }, React.createElement("i", {
      style: {
        position: 'absolute',
        inset: 0,
        transformOrigin: 'left'
      }
    }), React.createElement("span", {
      className: "mono",
      style: {
        position: 'relative',
        fontSize: 11.5,
        fontWeight: 800,
        color: 'var(--wb-white)',
        whiteSpace: 'nowrap'
      }
    }, l));
  }));
}
function GfxShift() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
    }
  }, React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "AI Phone \xB7 24h"), React.createElement("span", {
    style: {
      fontSize: 15,
      fontWeight: 800
    }
  }, "720h")), React.createElement("div", {
    className: "wb-g-week",
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(24,1fr)',
      gap: 3
    }
  }, Array.from({
    length: 24
  }, function (_, q) {
    return React.createElement("span", {
      key: q,
      style: {
        height: 16,
        borderRadius: 2,
        background: 'var(--grad-brand)',
        animationDelay: q * .06 + 's'
      }
    });
  })), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
    }
  }, React.createElement("span", {
    className: "mono"
  }, "Your team \xB7 9\u20135"), React.createElement("span", {
    style: {
      fontSize: 15,
      fontWeight: 800,
      color: 'var(--ink-400)'
    }
  }, "160h")), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(24,1fr)',
      gap: 3
    }
  }, Array.from({
    length: 24
  }, function (_, q) {
    return React.createElement("span", {
      key: q,
      style: {
        height: 16,
        borderRadius: 2,
        background: q >= 9 && q < 17 ? 'var(--ink-700)' : 'var(--sand-200)'
      }
    });
  })));
}
var RECAP = [['ra', 'Both Call Directions. One AI Phone.', 'Inbound answers everyone who calls you. Outbound follows up with everyone who didn’t. Same voice, same brain, one system, not two subscriptions stitched together.', GfxFlow], ['rb', 'First Ring. Every Time.', "No hold music, no voicemail, no \u201Cwe\u2019ll call you back.\u201D Every caller reaches a professional conversation in under a second, in the caller\u2019s own language.", GfxSpeed], ['rc', 'It Answers, Qualify then Books all your Leads', 'Service needed, location, budget, urgency, timeline, collected in the first conversation. Qualified leads land in your calendar. The rest get worked by SMS.', GfxQualify], ['rd', 'Never miss a Call or a Lead again!', '720 hours a month against your team’s 160. Nights, weekends, holidays, dinner rush, vacation weeks. The AI Phone does not notice the difference.', GfxShift]];
function Bundle() {
  var _React$useState5 = React.useState('idle'),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    orb = _React$useState6[0],
    setOrb = _React$useState6[1];
  var onAssembled = React.useCallback(function () {
    setOrb('listening');
    setTimeout(function () {
      return setOrb('breathing');
    }, 3000);
  }, []);
  var still = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  return React.createElement(Section, {
    id: "bundle",
    tight: true
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      alignItems: 'center',
      textAlign: 'center',
      maxWidth: 780,
      margin: '0 auto clamp(28px,3vw,46px)'
    }
  }, React.createElement(Badge, {
    tone: "gradient"
  }, "The complete AI Phone"), React.createElement("h2", {
    className: "h2",
    style: {
      maxWidth: 'none'
    }
  }, "Everything your phone line should have been doing all along."), React.createElement("p", {
    className: "lead"
  }, "Inbound and outbound, together at a reduced price, one AI Phone at the center of every conversation your business has.")), React.createElement("div", {
    className: "wb-recap"
  }, React.createElement(Card, {
    className: "hub wb-hub-ring",
    surface: "inverse",
    padding: "lg",
    radius: "xl",
    frame: false,
    elevation: "none",
    style: {
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 20,
      textAlign: 'center',
      minHeight: 'clamp(380px,36vw,500px)',
      color: '#FFFFFF',
      border: '3.5px solid transparent',
      boxShadow: '0 30px 70px -20px rgba(23,23,23,.55)'
    }
  }, React.createElement("style", null, '@property --hub-a{syntax:"<angle>";inherits:false;initial-value:0deg}.wb-hub-ring{background:radial-gradient(70% 50% at 50% 30%,rgba(252,99,6,.26) 0%,rgba(255,174,6,.08) 42%,transparent 72%) padding-box,linear-gradient(180deg,#1F1F1F 0%,#171717 55%,#111111 100%) padding-box,conic-gradient(from var(--hub-a),#FFAE06,#FC6306,#FFAE06 50%,#FC6306,#FFAE06) border-box!important;animation:wbHubRing 4s linear infinite}@keyframes wbHubRing{to{--hub-a:360deg}}@media(prefers-reduced-motion:reduce){.wb-hub-ring{animation:none}}'), React.createElement(Orbit, {
    size: 196,
    state: "breathing",
    detail: true,
    volume: true,
    basePath: A
  }), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      alignItems: 'center'
    }
  }, React.createElement("span", {
    style: {
      fontSize: 'clamp(23px,2.3vw,32px)',
      lineHeight: 1.15,
      letterSpacing: '-.03em',
      fontWeight: 800,
      color: '#FFFFFF'
    }
  }, "WinBoost AI Phone ", React.createElement("span", {
    style: {
      background: 'linear-gradient(90deg,#FFAE06,#FC6306)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent'
    }
  }, "Lead Closer")), React.createElement("div", {
    style: {
      display: 'flex',
      gap: 10,
      alignItems: 'baseline',
      marginTop: 4
    }
  }, React.createElement("span", {
    style: {
      fontSize: 16,
      fontWeight: 700,
      color: '#B8B8B8'
    }
  }, "starts at"), React.createElement("span", {
    style: {
      fontSize: 'clamp(34px,3.4vw,46px)',
      fontWeight: 800,
      letterSpacing: '-.03em',
      lineHeight: 1.15,
      paddingBottom: '.04em',
      background: 'var(--grad-brand)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent'
    }
  }, "$2,997")), React.createElement("span", {
    className: "mono",
    style: {
      color: '#B8B8B8',
      letterSpacing: '.16em'
    }
  }, "one-time \xB7 prepaid \xB7 yours forever")), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      width: '100%',
      maxWidth: 320,
      alignItems: 'center'
    }
  }, React.createElement(Button, {
    variant: "primary",
    size: "lg",
    full: true,
    arrow: true,
    href: window.WB_BUY_HREF ? window.WB_BUY_HREF(['in', 'out']) : '#final-form'
  }, "Buy AI Phone"), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 7,
      flexWrap: 'nowrap',
      justifyContent: 'center',
      whiteSpace: 'nowrap'
    }
  }, React.createElement("span", {
    className: "wb-bnd-a mono",
    style: {
      padding: '4px 9px',
      borderRadius: 999,
      background: '#292929',
      border: '1px solid #3A3A3A',
      color: '#FFFFFF'
    }
  }, "Inbound"), React.createElement("span", {
    style: {
      fontSize: 12,
      fontWeight: 800,
      color: '#8A8A8A'
    }
  }, "+"), React.createElement("span", {
    className: "wb-bnd-b mono",
    style: {
      padding: '4px 9px',
      borderRadius: 999,
      background: '#292929',
      border: '1px solid #3A3A3A',
      color: '#FFFFFF'
    }
  }, "Outbound"), React.createElement("span", {
    style: {
      fontSize: 12,
      fontWeight: 800,
      color: '#8A8A8A'
    }
  }, "="), React.createElement("span", {
    className: "wb-bnd-sum mono",
    style: {
      padding: '4px 9px',
      borderRadius: 999,
      background: 'var(--grad-brand)',
      color: 'var(--wb-white)',
      border: '1px solid transparent'
    }
  }, "Save $550")))), RECAP.map(function (_ref6, ri) {
    var _ref7 = _slicedToArray(_ref6, 4),
      cls = _ref7[0],
      title = _ref7[1],
      body = _ref7[2],
      Gfx = _ref7[3];
    return React.createElement(Card, {
      key: cls,
      className: cls + ' wb-deal' + (ri + 1),
      surface: "white",
      padding: "lg",
      radius: "xl",
      hoverable: true,
      style: _objectSpread({
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        justifyContent: 'center'
      }, dealStyle(ri))
    }, React.createElement("h3", {
      style: {
        fontSize: 'clamp(19px,1.65vw,23px)',
        lineHeight: 1.2,
        letterSpacing: '-.025em',
        fontWeight: 800
      }
    }, title), React.createElement(Gfx, null), React.createElement("p", {
      style: {
        fontSize: 15,
        lineHeight: 1.6,
        color: 'var(--text-secondary)'
      }
    }, body));
  }), React.createElement(Card, {
    className: "rwide wb-in-up",
    surface: "white",
    padding: "lg",
    radius: "xl",
    style: {
      animationDelay: '.62s'
    }
  }, React.createElement("div", {
    className: "wb-vs-card",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(340px,1.05fr) minmax(0,1fr)',
      gap: 'clamp(24px,3vw,52px)',
      alignItems: 'center'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 18
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'nowrap',
      gap: 'clamp(12px,1.6vw,28px)',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      alignItems: 'center',
      minWidth: 0,
      flex: '1 1 0'
    }
  }, React.createElement("img", {
    src: "assets/zfold8.png",
    alt: "A Samsung Galaxy Z Fold 8 open",
    style: {
      width: 236,
      maxWidth: '100%',
      height: 'auto',
      display: 'block',
      filter: 'drop-shadow(0 18px 26px rgba(23,23,23,.18)) drop-shadow(0 3px 6px rgba(23,23,23,.12))'
    }
  }), React.createElement("span", {
    className: "mono",
    style: {
      fontWeight: 800
    }
  }, "Samsung Z Fold 8 \xB7 $3,239 CAD"), React.createElement("img", {
    src: "assets/iphone-duo-fold.png",
    alt: "A folding phone open, showing mail and a summary feed",
    style: {
      width: 236,
      maxWidth: '100%',
      height: 'auto',
      display: 'block',
      marginTop: 6,
      filter: 'drop-shadow(0 18px 26px rgba(23,23,23,.18)) drop-shadow(0 3px 6px rgba(23,23,23,.12))'
    }
  }), React.createElement("span", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 6
    }
  }, React.createElement("img", {
    src: "assets/apple-intelligence.png",
    alt: "",
    style: {
      width: 26,
      height: 26,
      display: 'block'
    }
  }), React.createElement("span", {
    className: "mono",
    style: {
      fontWeight: 800
    }
  }, "iPhone DUO \xB7 $3,900 CAD"))), React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--ink-400)',
      fontSize: 15
    }
  }, "vs"), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      alignItems: 'center',
      minWidth: 0,
      flex: '0 0 auto'
    }
  }, still ? React.createElement(Orbit, {
    size: 200,
    state: "breathing",
    detail: true,
    volume: true,
    basePath: A
  }) : React.createElement(Orbit, {
    size: 200,
    state: orb,
    detail: true,
    assemble: true,
    volume: true,
    halo: orb === 'listening',
    onAssembled: onAssembled,
    basePath: A
  }), React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--green-500)',
      fontWeight: 800
    }
  }, "$2,997 \xB7 WinBoost AI Phone")))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14
    }
  }, React.createElement("h3", {
    style: {
      fontSize: 'clamp(24px,2.5vw,36px)',
      lineHeight: 1.15,
      letterSpacing: '-.03em',
      fontWeight: 800
    }
  }, "You need a WinBoost AI Phone, because the smartest phones money can buy still can\u2019t run your business autonomously."), React.createElement("p", {
    style: {
      fontSize: 'var(--fs-body)',
      lineHeight: 'var(--lh-body)',
      color: 'var(--text-secondary)'
    }
  }, "An iPhone DUO paired with Apple Intelligence at $3,900 CAD, or a Samsung Galaxy Z Fold 8 at $3,239 CAD, are remarkable devices. Neither can autonomously execute the WinBoost AI Phone workflow: answer every call, qualify the lead, handle objections, book the appointment, send the SMS and follow up, on its own, around the clock, without a person using it."), React.createElement("p", {
    style: {
      fontSize: 'clamp(18px,1.7vw,22px)',
      lineHeight: 1.3,
      letterSpacing: '-.02em',
      fontWeight: 800,
      paddingTop: 16,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, "And you never need to charge your WinBoost AI Phone.", React.createElement("br", null), " ", React.createElement("span", {
    style: {
      background: 'var(--grad-brand)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent'
    }
  }, "It lives in the cloud.")))))));
}
var FAQ_GROUPS = [['AI Phone / Product', [{
  q: 'Is WinBoost an AI receptionist, an AI call center, an AI voice agent, or AI customer service?',
  a: "All of those, in one AI Phone. It works as your AI receptionist for inbound calls, an AI voice agent that holds a real, natural conversation instead of reading a script, and an AI customer service and AI call center layer that answers, qualifies, books and follows up around the clock. WinBoost sells it as a single AI Phone Lead Closer rather than four separate tools."
}, {
  q: 'Can it replace my answering service?',
  a: 'Yes. An answering service takes a message and charges you per call or per month. Your AI Phone takes the booking instead, around the clock, including evenings, weekends and holidays. You pay once for the AI Phone and then $0.30 per minute it actually talks, with no monthly subscription.'
}, {
  q: 'Is the WinBoost AI Phone a virtual receptionist?',
  a: 'Yes, and more. It answers every inbound call like a trained receptionist: greets the caller, answers questions about your business, books the appointment and sends the confirmation by SMS. It can also call leads back, follow up on quotes and ask happy customers for a 5-star review, which a receptionist rarely has time to do.'
}, {
  q: 'What can it actually do on a call?',
  a: 'Answer in two rings, understand what the caller needs, answer questions from your own business information, qualify the lead, book into your calendar, text a confirmation or link during the call, transfer to a person when needed, and send your team a summary and transcript afterwards. It handles up to 20 calls at the same time.'
}, {
  q: 'Will an AI Phone replace my team?',
  a: 'No. It works alongside your people and existing workflows so your business responds faster, captures more opportunities and gives every customer the attention they deserve.'
}, {
  q: 'What languages does it speak?',
  a: "All of them. Your AI Phone can answer in any language your callers speak, including English, French, Spanish, Mandarin, Punjabi, Arabic and many more. It detects the caller\u2019s language and switches mid-call when they do, so every customer is served in the language they are most comfortable with."
}]], ['Your Team', [{
  q: 'What happens when a caller asks for a person?',
  a: 'It transfers the call live to whoever you nominate, with a warm handover so your team knows who is calling and why. If nobody is free, it takes a detailed message and texts your team immediately, so nothing is lost.'
}, {
  q: 'Will my staff have to learn a new system?',
  a: 'No. Bookings and contacts land in the calendar and CRM they already use.'
}]], ['Setup', [{
  q: 'How long does it take?',
  a: 'Under 7 days: creation, connection, testing, client validation and final touches.'
}, {
  q: 'Do I get a phone number?',
  a: 'Yes. Every AI Phone comes with its own local phone number, set up for you during the build. You can publish it as your main line, use it for a campaign or a new location, or forward your existing number to it.'
}, {
  q: 'Do I need to change my phone number?',
  a: 'No. Your AI Phone works with your existing business number through forwarding or porting, with no phone-system migration and no new hardware.'
}, {
  q: 'Which countries does it support?',
  a: "The United States and Canada, with local numbers and area codes in both. Your AI Phone speaks every language your callers do, and switches to the caller\u2019s language automatically."
}]], ['Pricing', [{
  q: 'How much does it cost?',
  a: 'Each AI Phone is a one-time purchase, from $2,997. After that you pay only for usage: $0.30 per minute on the Black Friday price (usually $0.40) and $0.05 per SMS. No monthly subscription, no contract and no minimum.'
}]], ['Integrations', [{
  q: 'Which tools do you connect to?',
  a: 'Calendars, CRMs and messaging tools including Google Calendar, HubSpot, Salesforce, GoHighLevel, Jobber, Slack and anything reachable through Zapier. After every call it writes the booking, transcript, tags and follow-up tasks into your tools automatically.'
}]], ['Security & Reliability', [{
  q: 'Is the WinBoost AI Phone HIPAA compliant?',
  a: 'Yes. The WinBoost AI Phone is built to meet HIPAA requirements, so clinics, dental offices and other healthcare practices can use it to answer patient calls and book appointments. Contact us to sign a Business Associate Agreement before going live.'
}, {
  q: 'Is the WinBoost AI Phone secure?',
  a: 'Yes. Calls, transcripts and customer details are encrypted in transit and at rest. Access is limited to your team and the WinBoost staff supporting your account, and your data is never sold or used to train external models.'
}, {
  q: 'Where is call data stored?',
  a: 'Encrypted in transit and at rest, in your region, and never used to train external models.'
}, {
  q: 'What if a call fails?',
  a: 'Calls route across redundant carriers, and anything unanswered falls back to your existing line.'
}]]];
function Faq() {
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    group = _React$useState8[0],
    setGroup = _React$useState8[1];
  return React.createElement(Section, {
    id: "faq"
  }, React.createElement(Head, {
    index: "18",
    label: "FAQ / objection library",
    title: "Every question. Answered."
  }), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '240px 1fr',
      gap: 56,
      alignItems: 'start'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2
    }
  }, FAQ_GROUPS.map(function (_ref8, i) {
    var _ref9 = _slicedToArray(_ref8, 1),
      g = _ref9[0];
    return React.createElement("button", {
      key: g,
      onClick: function onClick() {
        return setGroup(i);
      },
      style: {
        all: 'unset',
        cursor: 'pointer',
        padding: '12px 16px',
        borderRadius: 'var(--radius-sm)',
        fontSize: 14,
        fontWeight: 800,
        background: group === i ? 'var(--wb-white)' : 'transparent',
        color: group === i ? 'var(--wb-orange)' : 'var(--ink-600)',
        border: '1px solid ' + (group === i ? 'var(--border-card)' : 'transparent')
      }
    }, g);
  })), React.createElement(Accordion, {
    key: group,
    defaultOpen: [0],
    items: FAQ_GROUPS[group][1]
  })));
}
function FinalForm() {
  var FF = window.WB_FINAL_FORM || {};
  var AGENTS = FF.agentOptions || ['Inbound', 'Outbound', 'SMS (Reviews Collector)', 'Bundle'];
  var _React$useState9 = React.useState({
      name: '',
      business: '',
      phone: '',
      email: '',
      agentType: AGENTS[0]
    }),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    form = _React$useState0[0],
    setForm = _React$useState0[1];
  var _React$useState1 = React.useState('idle'),
    _React$useState10 = _slicedToArray(_React$useState1, 2),
    status = _React$useState10[0],
    setStatus = _React$useState10[1];
  var set = function set(k) {
    return function (e) {
      return setForm(_objectSpread(_objectSpread({}, form), {}, _defineProperty({}, k, e.target.value)));
    };
  };
  var submit = function () {
    var _ref0 = _asyncToGenerator(_regenerator().m(function _callee(e) {
      var r;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            e.preventDefault();
            if (!(status === 'sending')) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setStatus('sending');
            _context.n = 2;
            return window.wbSubmitLead(form, 'final-form');
          case 2:
            r = _context.v;
            setStatus(r.ok ? 'sent' : 'error');
            if (r.ok) setForm({
              name: '',
              business: '',
              phone: '',
              email: '',
              agentType: AGENTS[0]
            });
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function submit(_x) {
      return _ref0.apply(this, arguments);
    };
  }();
  return React.createElement(Section, {
    id: "final-form",
    style: {
      background: 'var(--wb-charcoal)'
    }
  }, React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 72,
      alignItems: 'start'
    }
  }, React.createElement("div", {
    className: "ff-left",
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24
    }
  }, React.createElement("p", {
    style: {
      margin: 0,
      paddingLeft: 16,
      borderLeft: '3px solid var(--wb-gold)',
      fontSize: 'clamp(19px,1.7vw,24px)',
      lineHeight: 1.3,
      fontWeight: 800,
      letterSpacing: '-.02em',
      color: '#FFFFFF',
      textWrap: 'balance'
    }
  }, "We\u2019re not here to sell you something you don\u2019t need. ", React.createElement("span", {
    style: {
      background: 'linear-gradient(90deg,#FFAE06,#FC6306)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent'
    }
  }, "You already know you need a WinBoost AI Phone to scale your business to the sun."), React.createElement("img", {
    src: "../../assets/orbit.png",
    alt: "",
    "aria-hidden": "true",
    style: {
      display: 'inline-block',
      width: '1.15em',
      height: '1.15em',
      verticalAlign: '-0.22em',
      marginLeft: '.3em',
      objectFit: 'contain'
    }
  })), React.createElement("h2", {
    className: "h2",
    style: {
      color: 'var(--wb-cream)'
    }
  }, "Ready to take action towards your AI Phone Lead Closer?"), React.createElement("p", {
    className: "lead",
    style: {
      color: 'var(--text-inverse-muted)'
    }
  }, "Start capturing the leads you already paid for. Tell us where to call and we\u2019ll show you exactly how your AI Phone will sound."), React.createElement("div", {
    className: "ff-figs",
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3,minmax(0,1fr))',
      gap: 'clamp(18px,2.2vw,32px)',
      padding: 'clamp(20px,2.2vw,28px) 0',
      borderTop: '1px solid rgba(255,250,245,.16)',
      borderBottom: '1px solid rgba(255,250,245,.16)'
    }
  }, React.createElement(AoFig, {
    v: "24/7",
    l: "Answering",
    c: "Nights, weekends, holidays",
    i: 0,
    divider: false
  }), React.createElement(AoFig, {
    v: "0",
    l: "Missed calls",
    c: "No voicemail, no queue",
    i: 1,
    divider: false
  }), React.createElement(AoFig, {
    v: React.createElement(React.Fragment, null, "7", React.createElement("span", {
      style: {
        fontSize: '.5em',
        letterSpacing: '-.02em',
        marginLeft: '.12em'
      }
    }, "days")),
    l: "To go live",
    c: "Number ported, scripts trained",
    i: 2,
    divider: false
  })), React.createElement("div", {
    className: "ff-checks",
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2,minmax(0,1fr))',
      gap: '14px 28px',
      alignItems: 'start'
    }
  }, React.createElement(CheckItem, {
    inverse: true
  }, "Live in under 7 days"), React.createElement(CheckItem, {
    inverse: true
  }, "Prepaid, no subscription"), React.createElement(CheckItem, {
    inverse: true
  }, "Satisfaction guaranteed"), React.createElement(CheckItem, {
    inverse: true
  }, "Scale faster, globally"), React.createElement(CheckItem, {
    inverse: true
  }, "24/7 uptime and monitoring"), React.createElement(CheckItem, {
    inverse: true
  }, "HIPAA compliant"))), React.createElement("div", {
    className: "ff-right",
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 18
    }
  }, React.createElement(Card, {
    surface: "inverse",
    padding: "lg",
    radius: "xl",
    style: {
      background: '#292929',
      borderColor: 'rgba(255,250,245,.2)'
    }
  }, React.createElement("form", {
    onSubmit: submit
  }, React.createElement("div", {
    className: "wb-ff-grid",
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2,minmax(0,1fr))',
      gap: 16
    }
  }, React.createElement(Field, {
    inverse: true,
    label: "Full Name",
    placeholder: "Sarah Mitchell",
    value: form.name,
    onChange: set('name'),
    name: "name",
    autoComplete: "name"
  }), React.createElement(Field, {
    inverse: true,
    label: "Business Name",
    placeholder: "Acme Plumbing",
    value: form.business,
    onChange: set('business'),
    name: "company",
    autoComplete: "organization"
  }), React.createElement(Field, {
    inverse: true,
    label: "Phone Number",
    type: "tel",
    placeholder: "(514) 555-0134",
    value: form.phone,
    onChange: set('phone'),
    name: "phone",
    autoComplete: "tel",
    inputMode: "tel"
  }), React.createElement(Field, {
    required: true,
    inverse: true,
    label: "Best Email",
    type: "email",
    placeholder: "sarah@acme.com",
    value: form.email,
    onChange: set('email'),
    name: "email",
    autoComplete: "email",
    inputMode: "email"
  }), React.createElement(Select, {
    inverse: true,
    label: "Agent type",
    options: AGENTS,
    value: form.agentType,
    onChange: set('agentType'),
    style: {
      gridColumn: 'span 2'
    }
  })), React.createElement("div", {
    style: {
      marginTop: 22,
      display: 'flex',
      flexDirection: 'column',
      gap: 10
    }
  }, React.createElement(Button, {
    variant: "primary",
    size: "lg",
    full: true,
    arrow: true,
    type: "submit",
    disabled: status === 'sending'
  }, status === 'sending' ? 'Sending…' : status === 'sent' ? 'Got it, we’ll call you' : 'Build My AI Phone'), status === 'sent' && React.createElement("p", {
    role: "status",
    style: {
      margin: 0,
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--green-500)'
    }
  }, "Thanks, an AI Phone consultant will call you shortly."), status === 'error' && React.createElement("p", {
    role: "alert",
    style: {
      margin: 0,
      fontSize: 13,
      fontWeight: 700,
      color: '#FF9E85'
    }
  }, "That didn\u2019t send. Please try again, or call us directly.")))), !FF.noVideo && React.createElement("div", {
    style: {
      borderRadius: 'var(--radius-lg)',
      overflow: 'hidden',
      border: '1px solid rgba(255,250,245,.18)',
      background: 'rgba(255,250,245,.06)',
      width: '100%',
      aspectRatio: '10 / 9'
    }
  }, React.createElement("video", {
    src: "assets/final-form.mp4",
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true,
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center 62%',
      display: 'block'
    }
  })))));
}
function EndCapture() {
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    armed = _React$useState12[0],
    setArmed = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    open = _React$useState14[0],
    setOpen = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    sent = _React$useState16[0],
    setSent = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    closed = _React$useState18[0],
    setClosed = _React$useState18[1];
  var close = function close() {
    setClosed(true);
    setOpen(false);
    setSent(false);
  };
  React.useEffect(function () {
    var queued = false;
    var check = function check() {
      queued = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      var p = (window.scrollY || 0) / max;
      if (p > 0.92) setArmed(true);else if (p < 0.86) {
        setArmed(false);
        setClosed(false);
      }
    };
    var onScroll = function onScroll() {
      if (!queued) {
        queued = true;
        requestAnimationFrame(check);
      }
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return function () {
      return window.removeEventListener('scroll', onScroll);
    };
  }, []);
  React.useEffect(function () {
    if (!armed || closed) return;
    var t = setTimeout(function () {
      return setOpen(true);
    }, 500);
    return function () {
      return clearTimeout(t);
    };
  }, [armed, closed]);
  var shown = armed && !closed;
  var shadow = '0 18px 50px -12px rgba(23,23,23,.28)';
  return React.createElement("div", {
    style: {
      position: 'fixed',
      right: 24,
      bottom: 24,
      zIndex: 60,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: 10,
      opacity: shown ? 1 : 0,
      pointerEvents: shown ? 'auto' : 'none',
      transition: 'opacity .4s var(--ease-standard)'
    }
  }, React.createElement("style", null, '.wb-ec-ring{position:absolute;width:76px;height:76px;border-radius:50%;border:2px solid var(--wb-orange);opacity:0;animation:wbEcRing 2.2s var(--ease-standard) infinite;pointer-events:none}@keyframes wbEcRing{0%{transform:scale(1);opacity:.5}70%{opacity:0}100%{transform:scale(1.85);opacity:0}}@media(prefers-reduced-motion:reduce){.wb-ec-ring{animation:none}}'), React.createElement("div", {
    style: {
      position: 'relative',
      width: 352,
      maxHeight: 'calc(100vh - 140px)',
      overflowY: 'auto',
      transformOrigin: 'bottom right',
      transform: open ? 'scale(1)' : 'scale(.86)',
      opacity: open ? 1 : 0,
      pointerEvents: open ? 'auto' : 'none',
      transition: 'transform .42s var(--ease-out),opacity .3s var(--ease-standard)'
    }
  }, React.createElement("div", {
    style: _defineProperty(_defineProperty({
      position: 'relative',
      background: 'var(--wb-white)',
      border: '1px solid var(--border-card)',
      borderRadius: 'var(--radius-xl)',
      boxShadow: '0 0 0 6px var(--surface-card-cream),0 0 0 7px var(--border-card)'
    }, "boxShadow", shadow), "overflow", 'hidden')
  }, React.createElement("div", {
    style: {
      height: 8,
      background: 'var(--grad-brand)'
    }
  }), React.createElement(FizzDrop, {
    depth: .74,
    density: 1
  }), sent ? React.createElement("div", {
    style: {
      position: 'relative',
      padding: '22px 20px',
      display: 'grid',
      gap: 10,
      justifyItems: 'center',
      textAlign: 'center'
    }
  }, React.createElement(SoundRibbon, {
    height: 20,
    active: true,
    tone: "light"
  }), React.createElement("strong", {
    style: {
      fontSize: 15,
      letterSpacing: '-.01em'
    }
  }, "Your AI Phone is on the line."), React.createElement("span", {
    style: {
      fontSize: 12.5,
      color: 'var(--text-secondary)'
    }
  }, "Tell it what your business needs and it fills in the rest.")) : React.createElement("div", {
    style: {
      position: 'relative',
      padding: '18px 20px 20px',
      display: 'grid',
      gap: 12,
      justifyItems: 'center',
      textAlign: 'center'
    }
  }, React.createElement("div", {
    style: {
      display: 'grid',
      gap: 4
    }
  }, React.createElement("span", {
    style: {
      fontSize: 12,
      fontWeight: 800,
      letterSpacing: '.12em',
      textTransform: 'uppercase',
      color: 'var(--wb-orange)'
    }
  }, "Hey Awesome shopper"), React.createElement("strong", {
    style: {
      fontSize: 16,
      letterSpacing: '-.01em'
    }
  }, "Talk Instead of Typing."), React.createElement("span", {
    style: {
      fontSize: 12.5,
      color: 'var(--text-secondary)'
    }
  }, "Speak with one of our AI Phone Experts to discuss your business needs.")), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 7
    }
  }, React.createElement("span", {
    "aria-hidden": "true",
    style: {
      display: 'flex',
      gap: 1.5,
      color: 'var(--wb-gold)',
      fontSize: 13,
      letterSpacing: '.04em'
    }
  }, "\u2605\u2605\u2605\u2605\u2605"), React.createElement("span", {
    style: {
      fontSize: 12,
      fontWeight: 700
    }
  }, "4.9/5"), React.createElement("span", {
    style: {
      fontSize: 12,
      color: 'var(--text-secondary)'
    }
  }, "by businesses like yours")), React.createElement(Button, {
    variant: "primary",
    full: true,
    arrow: true,
    onClick: function onClick() {
      var d = window.WB_AGENT_CALL;
      if (d) {
        window.location.href = d;
      }
      setSent(true);
    }
  }, "Call & Start Your Build"), React.createElement("span", {
    style: {
      fontSize: 11.5,
      color: 'var(--text-muted)'
    }
  }, "Available 24/7 \xB7 Just talk, we\u2019ll handle the rest."))), React.createElement("button", {
    onClick: close,
    "aria-label": "Close",
    style: {
      position: 'absolute',
      top: 10,
      right: 10,
      width: 26,
      height: 26,
      display: 'grid',
      placeItems: 'center',
      borderRadius: '50%',
      border: '1px solid var(--border-card)',
      background: 'var(--wb-white)',
      color: 'var(--ink-500)',
      fontSize: 14,
      fontWeight: 800,
      lineHeight: 1,
      cursor: 'pointer'
    }
  }, "\xD7")), React.createElement("div", {
    style: {
      position: 'relative',
      display: 'grid',
      placeItems: 'center'
    }
  }, !sent && React.createElement(React.Fragment, null, React.createElement("span", {
    className: "wb-ec-ring"
  }), React.createElement("span", {
    className: "wb-ec-ring",
    style: {
      animationDelay: '1.1s'
    }
  })), React.createElement("button", {
    onClick: function onClick() {
      return setOpen(!open);
    },
    "aria-label": open ? 'Hide the call invite' : 'Show the call invite',
    style: {
      position: 'relative',
      border: 'none',
      padding: 0,
      cursor: 'pointer',
      display: 'grid',
      placeItems: 'center',
      width: 76,
      height: 76,
      borderRadius: '50%',
      boxShadow: shadow,
      backgroundColor: 'var(--wb-white)'
    }
  }, React.createElement(Orbit, {
    size: 62,
    state: sent ? 'speaking' : 'listening',
    halo: true,
    basePath: A
  }))));
}
function Footer() {
  var cols = (window.WB_FOOTER_COLS || function (x) {
    return x;
  })([['Product', ['AI Phone Inbound', 'AI Phone Outbound', 'SMS Reviews Collector', 'Bundle', 'Pricing']], ['Company', ['About WinBoost', 'Careers', 'Contact', 'Partners', 'Become an AI Phone Online Retailer']], ['Resources', ['How it works', 'Hear a call', 'Integrations', 'FAQ', 'AI Phone directory', 'AI Receptionist directory', 'AI Sales Agent directory']], ['Legal', ['Privacy', 'Terms', 'Data processing']]]);
  var LINKS = {
    'Become an AI Phone Online Retailer': '/pages/become-an-online-retailer',
    'AI Phone directory': '/pages/ai-phone-directory',
    'AI Receptionist directory': '/pages/ai-receptionist-directory',
    'AI Sales Agent directory': '/pages/ai-sales-agent-directory'
  };
  var ASK_TEXT = "I want to know about WinBoost AI Phone Lead Closer, the AI phone for business from WinBoost.ai (winboost.ai). What is it, what does it do on a call, who is it for, and how does the pricing work? Please check winboost.ai for current details.";
  var ASK_Q = encodeURIComponent(ASK_TEXT);
  var askClick = function askClick(name) {
    try {
      window.wbTrack && window.wbTrack('ask_ai', {
        tool: name.toLowerCase()
      });
    } catch (e) {}
    if (name === 'Gemini') {
      try {
        navigator.clipboard && navigator.clipboard.writeText(ASK_TEXT);
      } catch (e) {}
    }
  };
  var askTitle = function askTitle(name) {
    return name === 'Gemini' ? 'Ask Gemini about WinBoost AI Phone Lead Closer. The question is also copied: paste it if the box opens empty.' : 'Ask ' + name + ' about WinBoost AI Phone Lead Closer';
  };
  var ASK_AI = [['ChatGPT', 'https://chatgpt.com/?q=' + ASK_Q, '#000', React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "26",
    height: "26",
    fill: "#fff"
  }, React.createElement("path", {
    d: "M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z"
  }))], ['Claude', 'https://claude.ai/new?q=' + ASK_Q, '#D97757', React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "26",
    height: "26",
    fill: "#fff"
  }, React.createElement("path", {
    d: "m4.7144 15.9555 4.7174-2.6471.079-.2307-.079-.1275h-.2307l-.7893-.0486-2.6956-.0729-2.3375-.0971-2.2646-.1214-.5707-.1215-.5343-.7042.0546-.3522.4797-.3218.686.0608 1.5179.1032 2.2767.1578 1.6514.0972 2.4468.255h.3886l.0546-.1579-.1336-.0971-.1032-.0972L6.973 9.8356l-2.55-1.6879-1.3356-.9714-.7225-.4918-.3643-.4614-.1578-1.0078.6557-.7225.8803.0607.2246.0607.8925.686 1.9064 1.4754 2.4893 1.8336.3643.3035.1457-.1032.0182-.0728-.164-.2733-1.3539-2.4467-1.445-2.4893-.6435-1.032-.17-.6194c-.0607-.255-.1032-.4674-.1032-.7285L6.287.1335 6.6997 0l.9957.1336.419.3642.6192 1.4147 1.0018 2.2282 1.5543 3.0296.4553.8985.2429.8318.091.255h.1579v-.1457l.1275-1.706.2368-2.0947.2307-2.6957.0789-.7589.3764-.9107.7468-.4918.5828.2793.4797.686-.0668.4433-.2853 1.8517-.5586 2.9021-.3643 1.9429h.2125l.2429-.2429.9835-1.3053 1.6514-2.0643.7286-.8196.85-.9046.5464-.4311h1.0321l.759 1.1293-.34 1.1657-1.0625 1.3478-.8804 1.1414-1.2628 1.7-.7893 1.36.0729.1093.1882-.0183 2.8535-.607 1.5421-.2794 1.8396-.3157.8318.3886.091.3946-.3278.8075-1.967.4857-2.3072.4614-3.4364.8136-.0425.0304.0486.0607 1.5482.1457.6618.0364h1.621l3.0175.2247.7892.522.4736.6376-.079.4857-1.2142.6193-1.6393-.3886-3.825-.9107-1.3113-.3279h-.1822v.1093l1.0929 1.0686 2.0035 1.8092 2.5075 2.3314.1275.5768-.3218.4554-.34-.0486-2.2039-1.6575-.85-.7468-1.9246-1.621h-.1275v.17l.4432.6496 2.3436 3.5214.1214 1.0807-.17.3521-.6071.2125-.6679-.1214-1.3721-1.9246L14.38 17.959l-1.1414-1.9428-.1397.079-.674 7.2552-.3156.3703-.7286.2793-.6071-.4614-.3218-.7468.3218-1.4753.3886-1.9246.3157-1.53.2853-1.9004.17-.6314-.0121-.0425-.1397.0182-1.4328 1.9672-2.1796 2.9446-1.7243 1.8456-.4128.164-.7164-.3704.0667-.6618.4008-.5889 2.386-3.0357 1.4389-1.882.929-1.0868-.0062-.1579h-.0546l-6.3385 4.1164-1.1293.1457-.4857-.4554.0608-.7467.2307-.2429 1.9064-1.3114Z"
  }))], ['Gemini', 'https://gemini.google.com/app?q=' + ASK_Q, 'linear-gradient(135deg,#4C8DF6,#B06AB3)', React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "26",
    height: "26",
    fill: "#fff"
  }, React.createElement("path", {
    d: "M11.04 19.32Q12 21.51 12 24q0-2.49.93-4.68.96-2.19 2.58-3.81t3.81-2.55Q21.51 12 24 12q-2.49 0-4.68-.93a12.3 12.3 0 0 1-3.81-2.58 12.3 12.3 0 0 1-2.58-3.81Q12 2.49 12 0q0 2.49-.96 4.68-.93 2.19-2.55 3.81a12.3 12.3 0 0 1-3.81 2.58Q2.49 12 0 12q2.49 0 4.68.96 2.19.93 3.81 2.55t2.55 3.81"
  }))], ['Perplexity', 'https://www.perplexity.ai/search?q=' + ASK_Q, '#20808D', React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "26",
    height: "26",
    fill: "#fff"
  }, React.createElement("path", {
    d: "M22.3977 7.0896h-2.3106V.0676l-7.5094 6.3542V.1577h-1.1554v6.1966L4.4904 0v7.0896H1.6023v10.3976h2.8882V24l6.932-6.3591v6.2005h1.1554v-6.0469l6.9318 6.1807v-6.4879h2.8882V7.0896zm-3.4657-4.531v4.531h-5.355l5.355-4.531zm-13.2862.0676 4.8691 4.4634H5.6458V2.6262zM2.7576 16.332V8.245h7.8476l-6.1149 6.1147v1.9723H2.7576zm2.8882 5.0404v-3.8852h.0001v-2.6488l5.7763-5.7764v7.0111l-5.7764 5.2993zm12.7086.0248-5.7766-5.1509V9.0618l5.7766 5.7766v6.5588zm2.8882-5.0652h-1.733v-1.9723L13.3948 8.245h7.8478v8.087z"
  }))]];
  var SOCIAL = [['Instagram', 'https://instagram.com/winboost.ai', 'linear-gradient(135deg,#f9ce34,#ee2a7b,#6228d7)', React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "#fff"
  }, React.createElement("path", {
    d: "M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077"
  }))], ['TikTok', 'https://tiktok.com/@winboost.ai', '#000', React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "#fff"
  }, React.createElement("path", {
    d: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"
  }))], ['YouTube', 'https://youtube.com/@winboost.ai', '#FF0000', React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "#fff"
  }, React.createElement("path", {
    d: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
  }))], ['X', 'https://x.com/winboost.ai', '#000', React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "#fff"
  }, React.createElement("path", {
    d: "M14.234 10.162 22.977 0h-2.072l-7.591 8.824L7.251 0H.258l9.168 13.343L.258 24H2.33l8.016-9.318L16.749 24h6.993zm-2.837 3.299-.929-1.329L3.076 1.56h3.182l5.965 8.532.929 1.329 7.754 11.09h-3.182z"
  }))]];
  return React.createElement("footer", {
    style: {
      background: 'var(--wb-charcoal)',
      borderTop: '1px solid var(--border-inverse)',
      padding: '72px 0 40px'
    }
  }, React.createElement("div", {
    className: "wrap"
  }, React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1.4fr repeat(4,1fr)',
      gap: 40
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 18
    }
  }, React.createElement(Logo, {
    variant: "stacked-white",
    height: 138,
    basePath: A,
    style: {
      alignSelf: 'flex-start',
      flex: 'none',
      width: 'auto',
      objectFit: 'contain',
      marginBottom: 45
    }
  }), React.createElement("p", {
    style: {
      fontSize: 14,
      color: 'var(--text-inverse-muted)'
    }
  }, "Premium AI Phone solutions for businesses that want to capture, engage and convert more opportunities."), window.WB_LANG ? React.createElement("a", {
    className: "wb-langlink",
    href: window.WB_LANG_URL(),
    hrefLang: window.WB_LANG.code,
    lang: window.WB_LANG.code,
    style: {
      alignSelf: 'flex-start'
    }
  }, window.WB_LANG.name) : null, React.createElement("address", {
    className: "wb-foot-addr",
    style: {
      fontStyle: 'normal',
      fontSize: 13.5,
      lineHeight: 1.65,
      color: 'var(--text-inverse-muted)'
    }
  }, React.createElement("b", {
    style: {
      color: 'var(--wb-cream)',
      fontWeight: 700
    }
  }, "WinBoost Enterprises Inc."), React.createElement("br", null), "Montr\xE9al, Qu\xE9bec, Canada", React.createElement("br", null), React.createElement("a", {
    href: "mailto:georges@winboost.ai",
    style: {
      color: 'var(--wb-cream)',
      textDecoration: 'none'
    }
  }, "georges@winboost.ai"), " \xB7 ", React.createElement("a", {
    href: "tel:+15149940638",
    style: {
      color: 'var(--wb-cream)',
      textDecoration: 'none'
    }
  }, "514-994-0638"))), cols.map(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
      t = _ref11[0],
      items = _ref11[1];
    return React.createElement("div", {
      key: t
    }, React.createElement("div", {
      className: "wb-label",
      style: {
        color: 'var(--text-inverse-muted)',
        marginBottom: 16
      }
    }, t), React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10
      }
    }, items.map(function (i) {
      return React.createElement("a", {
        key: i,
        href: window.WB_LINK ? window.WB_LINK(i) || LINKS[i] || WB_HOME('#hero') : LINKS[i] || WB_HOME('#hero'),
        style: {
          fontSize: 14,
          color: 'var(--wb-cream)',
          textDecoration: 'none',
          fontWeight: 600
        }
      }, i);
    })));
  })), React.createElement("div", {
    className: "wb-promos",
    style: {
      marginTop: 48,
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit,minmax(min(100%,420px),1fr))",
      gap: 16
    }
  }, React.createElement("a", {
    href: "/pages/become-an-online-retailer",
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 24,
      flexWrap: 'wrap',
      padding: '24px 28px',
      borderRadius: 'var(--radius-lg)',
      background: 'var(--grad-brand)',
      textDecoration: 'none'
    }
  }, React.createElement("span", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-charcoal)'
    }
  }, "Become an AI Phone Online Retailer"), React.createElement("span", {
    style: {
      fontSize: 'clamp(17px,1.6vw,22px)',
      fontWeight: 800,
      letterSpacing: '-.02em',
      color: 'var(--wb-charcoal)'
    }
  }, "Sell the AI Phone to your audience and keep $500 a sale. We build every one of them.")), React.createElement("span", {
    style: {
      fontSize: 15,
      fontWeight: 800,
      color: 'var(--wb-charcoal)',
      whiteSpace: 'nowrap'
    }
  }, "See the program \u2192")), window.WB_LINK && window.WB_LINK("Become an AI Phone Reseller") ? React.createElement("a", {
    href: window.WB_LINK("Become an AI Phone Reseller"),
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 24,
      flexWrap: 'wrap',
      padding: '24px 28px',
      borderRadius: 'var(--radius-lg)',
      background: 'var(--grad-brand)',
      textDecoration: 'none'
    }
  }, React.createElement("span", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-charcoal)'
    }
  }, "Become an AI Phone Reseller"), React.createElement("span", {
    style: {
      fontSize: 'clamp(17px,1.6vw,22px)',
      fontWeight: 800,
      letterSpacing: '-.02em',
      color: 'var(--wb-charcoal)'
    }
  }, "Sell the AI Phone in your store or kiosk and keep $500 a sale. We build every one of them.")), React.createElement("span", {
    style: {
      fontSize: 15,
      fontWeight: 800,
      color: 'var(--wb-charcoal)',
      whiteSpace: 'nowrap'
    }
  }, "See the program \u2192")) : null), React.createElement("div", {
    style: {
      marginTop: 48,
      paddingTop: 40,
      borderTop: '1px solid var(--border-inverse)'
    }
  }, React.createElement("div", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)',
      marginBottom: 6
    }
  }, "Ask AI about WinBoost"), React.createElement("p", {
    style: {
      fontSize: 14,
      color: 'var(--text-inverse-muted)',
      marginBottom: 18
    }
  }, "Learn more about WinBoost AI Phone Lead Closer with your favorite AI."), React.createElement("div", {
    className: "wb-ask-row",
    style: {
      display: 'flex',
      gap: 30,
      flexWrap: 'wrap'
    }
  }, ASK_AI.map(function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 4),
      name = _ref13[0],
      href = _ref13[1],
      bg = _ref13[2],
      icon = _ref13[3];
    return React.createElement("a", {
      key: name,
      href: href,
      target: "_blank",
      rel: "noopener",
      onClick: function onClick() {
        return askClick(name);
      },
      title: askTitle(name),
      "aria-label": 'Ask ' + name + ' about WinBoost AI Phone Lead Closer (opens in a new tab)',
      style: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        textDecoration: 'none',
        minWidth: 56,
        textAlign: 'center'
      }
    }, React.createElement("span", {
      style: {
        width: 56,
        height: 56,
        borderRadius: 16,
        background: bg,
        display: 'grid',
        placeItems: 'center'
      }
    }, icon), React.createElement("span", {
      style: {
        fontSize: 12,
        fontWeight: 700,
        color: 'var(--wb-cream)'
      }
    }, name));
  })), React.createElement("div", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)',
      marginTop: 32,
      marginBottom: 12
    }
  }, "Follow WinBoost on socials"), React.createElement("div", {
    style: {
      display: 'flex',
      gap: 14
    }
  }, SOCIAL.map(function (_ref14) {
    var _ref15 = _slicedToArray(_ref14, 4),
      name = _ref15[0],
      href = _ref15[1],
      bg = _ref15[2],
      icon = _ref15[3];
    return React.createElement("a", {
      key: name,
      href: href,
      target: "_blank",
      rel: "noopener",
      "aria-label": name,
      style: {
        width: 44,
        height: 44,
        borderRadius: '50%',
        background: bg,
        display: 'grid',
        placeItems: 'center',
        textDecoration: 'none'
      }
    }, icon);
  }))), React.createElement("div", {
    style: {
      marginTop: 40,
      paddingTop: 24,
      borderTop: '1px solid var(--border-inverse)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--text-inverse-muted)'
    }
  }, "\xA9 2026 WinBoost.ai \xB7 Built by expert Canadian AI Phone builders, for businesses in Canada, USA, Europe & UAE"), React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, React.createElement("span", {
    className: "wb-ftag-d"
  }, "Desire to WIN"), React.createElement("span", {
    className: "wb-ftag-m"
  }, "WinBoost, Desire To WIN")))));
}
Object.assign(window, {
  Integrations: Integrations,
  LiveBooking: LiveBooking,
  Portal: Portal,
  HighFive: HighFive,
  Bundle: Bundle,
  Faq: Faq,
  FinalForm: FinalForm,
  Footer: Footer
});